<!-- 表示二级选择的弹框 -->
<template>
  <div class = "twoSelect" v-show = 'showFlag'>
    <div class = "shade"></div>
    <div class = "contents">
      <div class = "choiceTwoSelect">
        <div class = "choiceTwoSelect-top clearfloat full_width">
          <div class = "ct-TwoSelect full_width">
            <div class = "clearfloat ct-TwoSelect-header full_width">
              <span class = "flags pull-left">已选择（<label class = "label">{{ choosedInfoId.length }}</label>/{{
                  maxCount
                }}）</span>
              <!-- 输入框的检索内容 -->
              <div class = "wordSearch pull-left" v-if="isInputSearch">
                <Input prefix = "ios-search"
                       @on-blur = "inputBlurHandle"
                       @on-focus = "searchInfoShowFlag = true"
                       v-model = "keywordContent"
                       placeholder = "请输入搜索内容" style = "width: 100%"
                       clearable/>
                <div class = "searchPopup overflowScroll" v-show = "keywordContent && searchInfoShowFlag">
                  <ul v-show = "searchResultInfoInfo.length > 0">
                    <li v-for = "item in searchResultInfoInfo" :key = "item.id2" @click.stop = "choosedSearchDeatil(item)">
                      <div class = "font1" v-html="item.title2Too"></div>
                      <div class = "font2">{{ item.title1 }} - <span v-html="item.title2Too"></span></div>
                    </li>
                  </ul>
                  <ul v-show = "searchResultInfoInfo.length === 0">
                    <li class = "text-center">
                      暂无检索内容
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div :class = "isInputSearch ? 'chooseContent': ''">
              <span
                  v-for = "(item, index) in choosedInfo"
                  @click = "_removeChoosedItem(item.id, index)"
                  :key = "item.id"
                  class = 'span1'
              ><span class = 'span2' :title = 'item.title'>{{ item.title }}</span><i>×</i></span>
            </div>
          </div>
          <div class = "ct-right">
            <div class = "ct-right-close" @click = "_cancel()">取消</div>
            <div class = "ct-right-sure" @click = "_define()">确定</div>
          </div>
        </div>
        <div class = "choiceTwoSelect-bottom">
          <div class = "bottom-left">
            <ul>
              <li
                  v-for = "(item, index) in oneSelectInfo"
                  :key = "item.id"
                  @click = "_oneMenuClickHandler(item.id, index)"
                  :class = "[oneTabIndex.indexOf(item.id) !== -1 ? 'active' : '']"
              >
                {{ item.title }}
              </li>
            </ul>
          </div>
          <div class = "bottom-right">
            <ul>
              <li
                  v-for = "item in twoSelectInfo"
                  :key = "item.id"
                  @click = "_twoMenuClickHandler(item)"
                  :class = "{active: choosedInfoId.join(',').indexOf(item.id) !== -1}"
              >
                <span class = 'pointer'>{{ item.title }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<!-- 样式部分 -->
<style lang = 'less' scoped>
@import "./index.less";
</style>

<!-- 表示js动作 -->
<script>

// 原数据拍平处理
let targetDelayeringInfo = []
// 导出模块
export default {

  // 名称
  name: 'cu-twoselect',

  // 表示数据
  data: function() {

    return {

      // 表示显示一级select
      oneSelectInfo: [],
      // 表示显示二级select
      twoSelectInfo: [],
      // 表示一级内容选中状态
      oneTabIndex: 0,
      // 表示二级内容选中状态
      twoTabIndex: '',
      // 表示被选中的id
      choosedInfo: [],
      // 表示选中的value
      choosedInfoId: [],
      // 表示关键字内容
      keywordContent: '',
      // 检索内容弹框显隐
      searchInfoShowFlag: true
    }
  },

  // 表示参数
  props: {

    // 表示显示隐藏
    showFlag: {
      type: Boolean,
      default: true
    },

    // 表示传递的总数据
    propinfo: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 表示被选中信息
    propChoosedInfo: {
      type: Array,
      default: () => {
        return []
      }
    },

    // 表示可以选择的最大个数
    maxCount: {
      type: Number,
      default: 3
    },

    // 是否需要检索输入框
    isInputSearch: {
      type: Boolean,
      default: true
    }
  },

  // 监听
  watch: {

    // 设置显隐变化
    showFlag: function(val) {

      // 判断是否被打开
      if ( val ) {

        this._initDataSetting()
        this.keywordContent = ''
        this.targetDelayeringHandle()
      }
    }
  },

  // 计算属性
  computed: {

    /**
     * @author lihh
     * @description 输入框输入数据后 计算存在的数据
     * */
    searchResultInfo() {
      if ( !this.keywordContent ) return []
      return targetDelayeringInfo.filter(({ title2 }) => title2.indexOf(this.keywordContent) !== - 1)
    },

    searchResultInfoInfo() {
      
      return this.searchResultInfo.map(item => ({
        ...item,
        title2Too:item.title2.split(this.keywordContent).join("<span style = 'color:blue'>" + this.keywordContent + "</span>")
      }))
    },
  },

  // 表示方法
  methods: {

    /**
     * @author lihh
     * @description 进行元素拍平化
     * */
    targetDelayeringHandle() {
      targetDelayeringInfo = []
      // 给数据添加标识 分别是title1 title2 title3
      const run = (code, area, level, target = {}) => {
        if ( code.indexOf('_') !== - 1 ) return
        target[`title${ level }`] = area
        target[`id${ level }`] = code
        if ( level === 2 ) {
          targetDelayeringInfo.push(Object.assign({}, target))
        }
      }

      // 递归解析数据
      const resolveData = (arrDetail, target, level) => {
        const { id, title } = arrDetail
        run(id, title, level, target)
        if ( arrDetail.subs ) {
          arrDetail.subs.forEach(item => resolveData(item, target, 2))
        }
      }

      // 循环遍历一级分类
      this.propinfo.forEach(item => {
        const targetArr = {}
        resolveData(item, targetArr, 1)
      })
    },

    /**
     * @author lihh
     * @description 表示被选中的检索明细
     * @param id1 表示一级分类
     * @param id2 表示二级分类
     * @param title2 表示二级标题
     * */
    choosedSearchDeatil({ id1, id2, title2 }) {

      // 分别选择二级分类  清空输入框
      this._oneMenuClickHandler(id1)
      this._twoMenuClickHandler({ id: id2, title: title2 })
      this.keywordContent = ''
    },

    /**
     * @author lihh
     * @description 输入框光标离开input事件
     * */
    inputBlurHandle() {
      let timer = setTimeout(() => {
        this.searchInfoShowFlag = false
        clearTimeout(timer)
        timer = null
      }, 300)
    },

    /**
     * @author lihh
     * @description 初期化数据
     */
    _initDataSetting: function() {

      // 设置初期值
      this.oneSelectInfo = []
      this.twoSelectInfo = []
      this.choosedInfo = []
      this.choosedInfoId = []
      this.oneTabIndex = ''

      // props参数 内容过渡
      this.choosedInfoId = JSON.parse(JSON.stringify(this.propChoosedInfo))
      // 如果id 存在显示对应的内容
      if ( this.choosedInfoId.length > 0 ) {

        // 获取二级内容
        let twoArr = []
        this.propinfo.forEach(item => {

          // 判断是否有二级菜单
          if ( item['subs'] ) twoArr.push(...item['subs'])
        })
        // 通过二级id 找到对应id的具体信息
        twoArr.forEach(item => this.choosedInfoId.indexOf(item['id']) !== - 1
            ? this.choosedInfo.push(item) : '')

        // 通过二级id 找到对应的一级id以及二级内容信息
        // 循环总的信息
        this.propinfo.forEach(item => {

          const twoMenu = item['subs']
          twoMenu.forEach(item1 => {

            if ( this.choosedInfoId.indexOf(item1['id']) !== - 1 ) {

              this.oneTabIndex += item['id'] + ','
              // 判断只需要显示第一条数据
              if ( this.twoSelectInfo.length === 0 ) this.twoSelectInfo = twoMenu
            }
          })
        })
      }

      // 退避数据
      let info = JSON.parse(JSON.stringify(this.propinfo))
      // 循环遍历
      info.forEach(item => {
        delete item['subs']
        this.oneSelectInfo.push(item)
      })
    },

    /**
     * @author lihh
     * @description 点击一级菜单筛选二级菜单
     * @param id 表示选中一级id
     */
    _oneMenuClickHandler: function(id = '') {

      // 设置选中下标
      this.oneTabIndex = id
      // 设置二级菜单
      this.twoSelectInfo = this.propinfo.filter(item => item.id === id)[0]['subs']
    },

    /**
     * @author lihh
     * @description 表示点击二级菜单选中
     * @param item 表示整行元素
     */
    _twoMenuClickHandler: function(item = {}) {

      // 判断个数
      if ( this.choosedInfoId.length >= this.maxCount ) {

        this.$Message.error(`最多可以选择${ this.maxCount }个`)
        return false
      }

      // 判断id是否已经被添加过
      if ( this.choosedInfoId.includes(item.id) ) {
        this.$Message.error(`该项已经被选择过,请重新选择`)
        return false
      }

      // 设置选中内容
      this.choosedInfo.push(item)
      this.choosedInfoId.push(item.id)
    },

    /**
     * @author lihh
     * @description 点击选中区域进行删除
     * @param id 表示选中id
     * @param index 表示选中的下标
     */
    _removeChoosedItem: function(id = '', index = 0) {

      // 删除元素
      this.choosedInfo.splice(index, 1)
      // 获取id对应下标
      let idIndex = this.choosedInfoId.indexOf(id)
      if ( idIndex !== - 1 ) this.choosedInfoId.splice(idIndex, 1)
    },

    /**
     * @author lihh
     * @description 点击取消按钮
     */
    _cancel: function() {

      this.$emit('_twoSelectSwitch', '0')
    },

    /**
     * @author lihh
     * @description 点击确定按钮
     */
    _define: function() {

      // 判断是否选择内容
      if ( this.choosedInfo.length === 0 ) {

        this.$Message.error('请选择行业领域')
        return false
      }
      this.$emit('_twoSelectSwitch', '0', this.choosedInfo)
    }

  },

  // 组件销毁前钩子
  beforeDestroy() {
    targetDelayeringInfo = []
  }
}
</script>



// WEBPACK FOOTER //
// src/packages/TwoSelect/CuTwoSelect/Cu-TwoSelect.vue